"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var date_fns_1 = require("@date-io/date-fns");

var config_1 = require("@react-form-fields/core/config");

var MuiPickersUtilsProvider_1 = require("material-ui-pickers/MuiPickersUtilsProvider");

var React = require("react");

var config_2 = require("../config");

var FormFieldsContext =
/** @class */
function (_super) {
  tslib_1.__extends(FormFieldsContext, _super);

  function FormFieldsContext(props) {
    var _this = _super.call(this, props) || this;

    config_1.setConfig(_this.props.config);
    return _this;
  }

  FormFieldsContext.prototype.componentDidUpdate = function (prevProps) {
    if (!this.props.config || prevProps.config === this.props.config) return;
    config_1.setConfig(this.props.config);
  };

  FormFieldsContext.prototype.render = function () {
    return React.createElement(MuiPickersUtilsProvider_1.default, {
      utils: date_fns_1.default,
      locale: config_2.getConfig().dateLocale
    }, this.props.children);
  };

  return FormFieldsContext;
}(React.PureComponent);

exports.default = FormFieldsContext;